import React from "react";
import { useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { KeysHelpHolder } from "./KeysHelpHolder";
import {LangDirectionContext} from "../../../context/LangDirectionContext";

const ArrowButton = styled.div`
  min-width: 109px;
  width: auto;
  height: 41px;
  background-color: rgb(27, 170, 225);
  position: absolute;
  top: 0;
  color: white;
  padding: 0 20px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;

  span {
    padding: 0 5px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
  }

  .arrow {
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.white};
    border-width: 0 3px 3px 0;
    padding: 5px;
    transform: rotate(-45deg);
    ${(props) =>
      props.direction === "rtl" &&
      css`
        transform: rotate(135deg);
      `};
  }
`;

export function NextKey({ ...props }) {
  const { t } = useTranslation();
  const direction = React.useContext(LangDirectionContext);

  return (
    <KeysHelpHolder
      title={t("tapNEXTtoConfirmAnAnswer")}
      subtitle={t("thisWillAutomaticallyMove")}
      {...props}
    >
      <svg
        width="109"
        height="165"
        viewBox="0 0 109 165"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M42.7756 97.5562C42.7756 97.5562 43.2916 96.9112 44.0655 96.6532C44.8395 96.3953 45.4845 96.3953 45.4845 96.3953C45.4845 96.3953 45.4845 95.6213 45.7425 94.7183C46.2584 93.4284 47.1614 91.4935 47.5484 88.6556C47.8064 86.5917 48.0643 84.1408 48.1933 81.5609C48.3223 78.4651 48.7093 74.8532 48.0643 71.6284C47.2904 67.2426 45.8715 63.8888 44.3235 59.7609C43.1626 56.6651 41.6146 52.7953 40.8407 49.8284C39.1638 43.8947 37.6158 38.4769 37.8738 34.9941C38.1318 32.5432 39.5507 31.1243 40.9697 30.7373C46.2584 29.1893 48.0643 35.5101 51.0312 41.1858C52.5791 44.2816 55.03 47.3775 56.191 49.8284C57.6099 52.6663 58.1259 54.2142 58.1259 54.2142C58.1259 54.2142 61.2217 50.7314 63.6726 48.9254C64.9626 48.0225 66.2525 46.4746 67.1555 46.0876C68.4454 45.4426 71.9283 45.4426 73.6052 47.2485C76.701 50.7314 78.12 57.568 78.12 57.568C78.12 57.568 80.9578 57.3101 82.7638 59.503C84.6987 61.8248 85.2146 63.1148 87.0206 67.7586C87.0206 67.7586 89.8584 66.0816 92.3093 68.6615C94.3732 70.7254 95.6632 74.8532 97.2111 79.239C98.2431 82.3349 100.178 83.7538 100.178 88.5266C100.178 93.9444 100.694 100.265 101.081 106.328C101.21 110.327 100.952 114.196 101.597 117.55C102.371 121.291 101.468 119.227 105.467 126.838C106.112 127.999 106.37 130.966 104.822 133.288C98.243 142.704 72.9602 155.217 64.3176 142.317C62.2537 139.221 61.0928 135.738 59.1578 133.675C55.804 130.321 51.0312 130.321 47.0324 126.58C39.8087 120.001 32.1981 114.97 30.1342 110.972C29.7472 110.198 29.2312 107.231 28.4572 104.006C27.9413 101.813 26.6513 99.8781 26.2643 97.9432C25.1034 92.7834 23.8135 91.3645 23.6845 88.9136C23.6845 86.9787 25.1034 83.7538 24.7164 80.916C24.5874 79.755 23.8135 77.5621 23.5555 75.8852C23.1685 73.1763 23.9425 70.4675 26.2643 70.0805C28.0703 69.8225 29.7472 70.3385 31.9401 72.2734C34.52 74.7243 36.8419 78.3361 37.8738 81.045C38.9058 83.6248 38.1318 86.0757 38.1318 86.0757C38.1318 86.0757 38.9058 86.7207 39.4217 88.5266C39.6797 89.1716 39.9377 90.5905 40.1957 91.2355C40.8407 92.9124 41.3567 94.2024 41.6146 95.1053C41.8726 95.8793 41.6146 96.3953 41.6146 96.3953L42.7756 97.5562Z"
          fill="white"
        />
        <path
          d="M54.6428 35.2521C54.6428 42.0887 49.0961 47.6355 42.2594 47.6355C35.4227 47.6355 29.876 42.0887 29.876 35.2521C29.876 28.4154 35.4227 22.8686 42.2594 22.8686C49.0961 22.8686 54.6428 28.4154 54.6428 35.2521ZM42.2594 25.4485C36.8417 25.4485 32.3269 29.8343 32.3269 35.381C32.3269 40.7988 36.7127 45.3136 42.2594 45.3136C47.6772 45.3136 52.192 40.9278 52.192 35.381C52.063 29.8343 47.6772 25.4485 42.2594 25.4485Z"
          fill="white"
        />
        <path
          opacity="0.5"
          d="M63.8017 68.6615C63.9307 68.9195 65.4786 68.2745 65.6076 66.4686C65.7366 63.8887 65.0917 58.342 65.4786 56.2781C65.9946 53.5692 67.1556 50.0863 66.3816 49.5704C65.7366 51.2473 63.5437 52.0213 62.5118 52.0213C60.0609 52.0213 58.126 53.9562 58.126 53.9562C58.126 53.9562 58.513 54.8591 59.2869 57.31C59.9319 59.8899 63.2857 67.5006 63.8017 68.6615Z"
          fill="url(#paint0_linear)"
        />
        <path
          opacity="0.5"
          d="M81.474 73.8213C81.474 73.8213 80.442 72.5313 79.797 69.4355C79.1521 66.2106 78.1201 57.31 78.1201 57.31C78.1201 57.31 78.8941 58.471 79.539 60.9219C80.055 62.9858 79.539 62.5988 80.184 69.0485C80.313 70.0804 81.345 72.1443 81.474 73.8213Z"
          fill="url(#paint1_linear)"
        />
        <path
          opacity="0.5"
          d="M90.5034 75.3692C90.5034 75.3692 89.6004 74.8532 89.0845 73.3053C88.4395 71.8863 87.6655 67.7585 87.6655 67.7585C87.6655 67.7585 88.4395 68.2745 88.9555 69.4355C89.4714 70.3384 88.9555 70.2094 89.4714 73.1763C89.4714 73.6923 90.3744 74.7242 90.5034 75.3692Z"
          fill="url(#paint2_linear)"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="65.4991"
            y1="52.3241"
            x2="59.5623"
            y2="65.4987"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0" />
            <stop offset="1" />
          </linearGradient>
          <linearGradient
            id="paint1_linear"
            x1="82.344"
            y1="64.5265"
            x2="77.6947"
            y2="66.3654"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0" />
            <stop offset="1" />
          </linearGradient>
          <linearGradient
            id="paint2_linear"
            x1="89.9962"
            y1="71.2686"
            x2="88.2385"
            y2="71.9637"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity="0" />
            <stop offset="1" />
          </linearGradient>
        </defs>
      </svg>
      <ArrowButton direction={direction}>
        <span>{t("next")}</span>
        <div className="arrow" />
      </ArrowButton>
    </KeysHelpHolder>
  );
}
